import styles from "./Loader.module.css";

export default function Loader(props) {
  return (
    <div class={styles["lds-ring"]}>
      <div
        style={{
          border: `2px solid ${props.color || "#4ade80"}`,
          borderColor: `${
            props.color || "#4ade80"
          } transparent transparent transparent`,
        }}
      ></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
